import {Route, Routes, Navigate} from 'react-router-dom'
import { AcessoPesquisa } from './components/AcessoPesquisa'
import { ResponderPesquisaLayout } from '../../../_metronic/layout/ResponderPesquisaLayout'

const ResponderPesquisaPage = () => {
  return (
    <Routes>
      <Route element={<ResponderPesquisaLayout />}>        
        <Route path=':chave' element={<AcessoPesquisa />} />
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  )
}

export {ResponderPesquisaPage}
